module.exports = __webpack_public_path__ + "static/image_6_thumb-009ca28155b6aa159d50361edda8d2b5.jpg";